import request from "./httpService";

const SMS_TEMPLATE_ENDPOINT = '/smstemplate';

const saveTemplate = (data) => {
    return request({
        method: "POST",
        url: `${SMS_TEMPLATE_ENDPOINT}`,
        data: data,
    });
};

const getTemplates = () => {
    return request({
        method: "GET",
        url: `${SMS_TEMPLATE_ENDPOINT}`,
    });
};

const getTemplate = (id) => {
    return request({
        method: "GET",
        url: `${SMS_TEMPLATE_ENDPOINT}/${id}`,
    });
};

const updateTemplate = (id, data) => {
    return request({
        method: "PUT",
        url: `${SMS_TEMPLATE_ENDPOINT}/${id}`,
        data: data,
    });
};

const deleteTemplate = (id) => {
    return request({
        method: "DELETE",
        url: `${SMS_TEMPLATE_ENDPOINT}/${id}`,
    });
};

const saveConfig = (data) => {
    return request({
        method: "POST",
        url: `${SMS_TEMPLATE_ENDPOINT}/config/save`,
        data: data,
    });
};

const getConfig = () => {
    return request({
        method: "GET",
        url: `${SMS_TEMPLATE_ENDPOINT}/config/get`,
    });
};

const getCommunicationTypes = () => {
    return request({
        method: "GET",
        url: `${SMS_TEMPLATE_ENDPOINT}/metadata/communication-types`,
    });
};

const getPlaceholders = () => {
    return request({
        method: "GET",
        url: `${SMS_TEMPLATE_ENDPOINT}/metadata/placeholders`,
    });
};

export const SmsTemplateService = {
    saveTemplate,
    getTemplates,
    getTemplate,
    updateTemplate,
    deleteTemplate,
    saveConfig,
    getConfig,
    getCommunicationTypes,
    getPlaceholders,
};